<template>
<v-container>
   <v-card flat>
       <v-card-text class="justify-center">
         <v-layout v-if="!loading" row wrap>
        <v-flex xs3>
          <v-text-field
          class="input mr-2"
            label="Name"
            v-model="form.name"
          />
      </v-flex>
       <v-flex xs3>
          <v-text-field
          
          class="input mr-2"
            label="Email"
            v-model="form.email"
          />
      </v-flex>
       <v-flex xs3>
          <v-text-field
          class="input mr-2"
            label="Domain"
            v-model="form.domain"
          />
      </v-flex>
      <v-flex xs3>
        <v-btn @click="scanNewUser"  style="margin-top:15px" v-if="!loading" small class="teal white--text">
          <v-icon small >fas fa-search</v-icon>&nbsp;
          Scan 
        </v-btn>
        <v-btn @click="showDialog =true"  style="margin-top:15px" v-if="!loading" small class="teal white--text">
          <v-icon small >fas fa-plus</v-icon>&nbsp;
          Grant 
        </v-btn>
        
      </v-flex>
        </v-layout>
      <p v-if="loading" class="text-xs-center headline"><strong>Scanning for New User ....</strong> </p>
      <v-layout row wrap class="teal white--text body-1" style="min-height:30px">
          <v-flex xs1 class="teal white--text" style="height:25px">
            <v-checkbox  dense single-line small v-model="selectall" />
          </v-flex>
          <v-flex xs3 class="teal white--text" style="padding-left:5px;padding-top:10px;margin-top:10px;margin-bottom:10px;height:30px"><strong>Name</strong></v-flex>
          <v-flex xs3 class="teal white--text" style="padding-left:5px;padding-top:10px;margin-top:10px;margin-bottom:10px;height:30px"><strong>Email</strong></v-flex>
          <v-flex xs3 class="teal white--text" style="padding-left:5px;padding-top:10px;margin-top:10px;margin-bottom:10px;height:30px"><strong>Ldap</strong></v-flex>
          </v-layout>
         <template v-for="user in users">
           <v-layout row wrap class="body-1">
             <v-flex xs1  >
              <v-checkbox  dense single-line small v-model="user.selected"/>
            </v-flex>
              <v-flex xs3  style="padding-left:5px;">{{user.first_name}} - {{user.last_name}} </v-flex>
              <v-flex xs3 style="padding:0px;"  >
                <v-text-field 
                v-model="user.email"
               hide-details

                    dense
                 
                    single-line  
                    height="30px"
                    style=" top:0px;padding:0px;margin:0px;"
                  
                />
                </v-flex>

              <v-flex xs3 style="padding-left:5px;" >{{user.ldap_string}}</v-flex>
             
              <v-flex xs3 >
    
             <!--    <template v-for="(key,index) in user.data.data">
                  <v-switch :label="key.name" v-model="key.access" />
                  </template> -->
              </v-flex>
              <v-flex xs12 style="border-top:1px solid #eee">&nbsp;</v-flex>
          </v-layout>
           </template>
     </v-card-text>
     <v-card-actions class="justify-center">
       <ScaleLoader v-if="loading" color = '#36D7B7'
        ></ScaleLoader>
       <br/>
       </v-card-actions>
  </v-card>
        
      <v-dialog v-model="showDialog" max-width="500px">
        <CompanyAccess v-if="showDialog" v-on:closeDialog="closeDialog" />
    
      </v-dialog>
  </v-container>
</template>
<style>
</style>
<script>
//import UserModel from '../../api/service/UserService.js';

import UserModel from '@/api/service/UserService';
import CompanyModel from '@/api/service/CompanyService'
import {RotateSquare2} from 'vue-loading-spinner'
import { ScaleLoader	 } from '@saeris/vue-spinners'
import CompanyAccess from './CompanyAccess.vue'
import { PacmanLoader	 } from '@saeris/vue-spinners'

 

export default {
   components: {
     CompanyAccess,
      RotateSquare2,
      ScaleLoader	,
      PacmanLoader
  },
  data() {
    return {
      showDialog:false,
      selectall:false,
      companies:[],
        pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 100,
      sortBy: 'fat',
      totalItems: 0,
      rowsPerPageItems: [1, 2, 4, 8, 16]
    },
    
       selected: [],
        headers: [
          { text: 'Id', value: 'id' },
          { text: 'Email', value: 'email' },
          { text: 'Ldap', value: 'ldap_string' },
          {}
        ],
        
    form: {
      name:"",email:"",domain:""
    },
    loading:false,
    users:[],
    mapCompany:false
    }
  },
  created () {
    CompanyModel.findAll()
    .then($abc => {
      this.companies= $abc;
    })
    /*
    var navigate = this.$router;
     */
    /*setTimeout(() => {
          navigate.replace('/users')
        }, 5000);*/

  },
  watch: {
    selectall() {
      for(var $i=0;$i<this.users.length;$i++) {
        this.users[$i].selected = this.selectall
      }
      this.$forceUpdate()
    }
  },
  
  methods: {
    /*selectUser(user) {
      user.selected = !user.selected
    },*/
    selectAll() {
      
    },
    async closeDialog($company,$email_domain) {
      var $list =[]
      var $user ={}
      for(var $i=0;$i<$company.length;$i++) {
        if($company[$i].access) {
          $list.push({"id":$company[$i].id,"name":$company[$i].name})
        }
      }
        for(var $i=0;$i<this.users.length;$i++) {
          var $user={}
          if(this.users[$i].selected) {
          if(this.users[$i].data) {
          $user.company_list = JSON.stringify($list)   
           $user.id = this.users[$i].data.id
            await UserModel.update($user)
          } else {
            $user=this.users[$i]
            //$user.default_company_id = 100
          $user.company_list = JSON.stringify($list)
          //var $suffix = 
          //$user.email = $user.email.substr(0,$user.email.indexOf('@'))+'@'+$email_domain
         $user.company_id = $list.length >0 ? $list[0].id : 0
            
            await UserModel.create($user)
          }
          }
      }
      this.showDialog=false
      //window.location.assign('/#/users')
      this.$router.push('/users')
    },
    scanNewUser() {
      this.loading=true
      UserModel.scan(this.form).then(response=> {
        console.log(response)
        this.loading=false
        this.users = response.data.data
            this.mapCompany=true
        navigate.replace('/users')      
      }).catch(error => {
        console.log(error)
      });
    }
  }
};
</script>

<style  scoped>
table {border-spacing: 2px;}
td    {padding: 6px;vertical-align:top}
.v-data-table.theme--light.v-table thead th
{
    background-color:teal;
}
  .style-input {
    padding:0px;
    margin:0px;
    width:100%;
  }
  .style-input1 {
    background-color:yellow;
  }
  .theme--light.v-datatable thead th  {
    background:teal;
    color:white;
  }
.v-input v-input--selection-controls v-input--checkbox theme--light
{
  padding-top:0px;margin-top:0px;
}
</style>
